import React from 'react';
const DefaultLinkRenderer = ({ AnchorElement, children, ...props }) => (React.createElement(AnchorElement, { ...props }, children));
export default DefaultLinkRenderer;
//# sourceMappingURL=DefaultLinkRenderer.js.map